import { useEffect, useState } from 'react';
import NoteTable from '../tables/NoteTable';
import { NoteDTO } from '../../services/apiClient';
import { useNoteApi } from '../../hooks/useNoteApi';
import { confirmDelete } from '../../utils/sweetAlertUtils';
import { useNavigate } from 'react-router-dom';

interface ViewNoteHistoryProps {
  memberId: string;
}

const ViewNoteHistory: React.FC<ViewNoteHistoryProps> = ({ memberId }) => {
  const { search, remove, extract, resolve, isLoading, error } = useNoteApi();
  const [items, setItems] = useState<NoteDTO[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();

  const fetchItems = async (page: number, size: number, filters: any) => {
    try {
      const response = await search({
        filters: {
          memberId: memberId,
        },
        page,
        pageSize: size,
        sortBy: 'CreatedUtc',
        sortDescending: true,
      });
      setItems(response?.data?.results || []);
      setTotalRecords(response?.data?.totalCount || 0);
    } catch (error) {
      console.error('Error fetching Notes:', error);
    }
  };

  useEffect(() => {
    fetchItems(currentPage, pageSize, {});
  }, [currentPage, pageSize]);

  const handleDelete = async (dto: NoteDTO) => {
    const confirmed = await confirmDelete();
    if (!confirmed) return;

    try {
      await remove(dto.id || '');
      await fetchItems(currentPage, pageSize, {});
    } catch (error) {
      console.error('Error deleting Note:', error);
    }
  };

  const handleResolve = async (dto: NoteDTO) => {
    try {
      await resolve(dto.id || '');
      await fetchItems(currentPage, pageSize, {});
    } catch (error) {
      console.error('Error resolving Note:', error);
    }
  };

  return (
    <NoteTable
      data={items}
      handleEdit={(dto) => navigate(`/admin/notes/${dto.id}`)}
      handleDelete={handleDelete}
      handleResolve={handleResolve}
      currentPage={currentPage}
      totalPages={Math.ceil(totalRecords / pageSize)}
      setCurrentPage={setCurrentPage}
      pageSize={pageSize}
      setPageSize={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default ViewNoteHistory;
